export default {
	common: {
		ok: 'Ok',
		save: 'Save',
		save_and_next: 'Save and next',
		yes: 'Yes',
		no: 'No',
		cancel: 'Cancel',
		update: 'Update',
		create: 'Create',
		back: 'Back',
		delete: 'Delete',
		delete_confirm: 'This entry will be removed permanently.',
		send: 'Send',
		search: 'Search...',
		all: 'All',
		none: 'None',
		unknown: 'Unknown',
		assigned: 'Assigned',
		not_assigned: 'Not assigned',
		please_select: 'Please select',
		search_or_enter: 'Search or enter your own wording',
		use_own_wording: 'Use “{text}”',
		no_results: 'No matches',
		saved: 'Saved',
		locked: 'Locked',
		to_login: 'To login',
		expired_session: 'Your session has expired. Please log in again.',
		clear_image: 'Clear image',
		preview: 'Preview',
		edit: 'Edit',
		edit_avatar: 'Edit avatar',
		options: 'Options',
		service_not_available: 'An error occurred, please try again later.',
		// efErrorBoundary: what is left where a part of the ui failed to render
		render_failed: 'This part of the page could not be displayed.',
		page_failed: 'This page could not be displayed.',
		created: 'Created',
		updated: 'Updated',
		loading: 'Loading',
		load_failed: 'The data could not be loaded.',
		retry: 'Try again',
		next: 'Next',
	},
	// Short titles (tooltips) for buttons without a visible label. Keep them to a few words,
	// they only have to tell the user what the button does.
	buttons: {
		document_view: {
			back: 'Back',
			pdf: 'Download as PDF',
			pdf_short: 'PDF',
			open_pdf: 'Open the PDF in the browser',
			print: 'Print',
		},
		branding_editor: {
			reset_all: 'Take everything from the default again',
			reset_record: 'Take everything from the admin design again',
		},
		own_design: {
			adopt: 'Take the admin design again',
		},
		block_editor: {
			as_html: 'Take as HTML',
		},
		text_templates: {
			reset: 'Reset to the inherited text',
			reset_all: 'Take every text from the default again',
			reset_record: 'Take every text from the admin design again',
		},
		letterhead_editor: {
			reset: 'Reset everything to what is inherited',
			reset_record: 'Take everything from the admin design again',
			field_default: 'Reset to the inherited value',
			upload: 'Upload image',
			remove: 'Remove',
			image_default: 'Default image',
			remove_image: 'Remove the image',
			download_pdf: 'Download PDF',
			open_pdf: "Open in the browser's PDF viewer",
			add_line: 'Add line',
			add_column: 'Add column',
			add_row: 'Add line',
			add_item: 'Add entry',
			up: 'Move up',
			down: 'Move down',
		},
		generic: {
			fill: 'Copy the template in',
			reset: 'Reset',
		},
		mail_theme: {
			reset_all: 'Let every field follow the default again',
			reset_record: 'Take everything from the admin design again',
			send_test: 'Send test mail',
			reset: 'Reset to the inherited value',
		},
		create: 'Create new',
		edit: 'Edit',
		delete: 'Delete',
		save: 'Save',
		reset: 'Reset',
		refresh: 'Refresh',
		close: 'Close',
		details: 'Show details',
		collapse: 'Collapse',
		expand: 'Expand',
		password_show: 'Show password',
		password_hide: 'Hide password',
		table: {
			filter: 'Show filters',
			refresh: 'Refresh table',
			export: 'Download table',
			export_format: 'Select file format',
			reset_settings: 'Delete table settings',
			save_settings: 'Remember table settings',
			settings: 'Configure columns',
			details: 'Show row details',
			show_cards: 'Show as list',
			show_table: 'Show as table',
			sort_direction: 'Reverse sort order',
		},
		pagination: {
			first: 'First page',
			previous: 'Previous page',
			next: 'Next page',
			last: 'Last page',
		},
		file: {
			upload: 'Upload file',
			remove: 'Remove file',
		},
		image: {
			edit: 'Change image',
			delete: 'Delete image',
			rotate_left: 'Rotate left',
			rotate_right: 'Rotate right',
			full: 'Select whole image',
		},
		header: {
			menu: 'Open menu',
			applications: 'Applications',
			sso_apps: 'Back to {provider}',
			context: 'Switch context',
			language: 'Select language',
			notifications: 'Notifications',
			close_notification: 'Close notification',
			profile: 'Profile',
			search: 'Search',
			context_mode: 'Switch mode',
		},
		sidebar: {
			minimize: 'Collapse or expand menu',
			close: 'Close menu',
		},
		user: {
			create: 'Invite person',
			edit: 'Edit person',
			delete: 'Remove person',
			resend_invitation: 'Resend invitation',
			lock: 'Lock person',
		},
		role: {
			create: 'Create role',
			edit: 'Edit role',
			delete: 'Delete role',
		},
		webhook: {
			create: 'Create webhook',
			edit: 'Edit webhook',
			delete: 'Delete webhook',
			enable: 'Enable webhook',
			requests: 'Show requests',
			replay: 'Resend request',
			delete_request: 'Delete request',
		},
		token: {
			create: 'Create token',
			revoke: 'Revoke token',
		},
		legal_page: {
			restore_all_defaults: 'Put the default text back on all three pages',
		},
		config: {
			reload: 'Reload settings',
			reset: 'Reset to default value',
			save: 'Save setting',
		},
		maintenance: {
			reload: 'Reload data',
			toggle_details: 'Collapse or expand details',
			raw: 'Show raw data',
			wipe_metrics: 'Reset metrics',
			retry_job: 'Retry job',
			delete_job: 'Delete job',
			delete_all_jobs: 'Delete all failed jobs',
			clear_mail_log: 'Clear the mail counters and failures',
			test_mail: 'Send a test mail',
			test_pdf: 'Print a sample letter as PDF',
		},
	},
	pages: {
		admin: {
			users: {
				title: 'People',
				teams: 'Teams',
				events: 'Events',
				label: {
					email_not_verified: 'E-mail not verified',
					is_locked: 'Locked',
					anonymized: 'Anonymized',
					two_factor: '2FA',
					two_factor_title: 'Two-factor authentication set up',
				},
				send_password_reset: 'Send password reset link',
				resend_invitation: 'Resend invitation',
				resend_invitation_confirm:
					"Resend the invitation to '{name}'? Anyone who has never signed in receives a new link to set their password, otherwise a password reset link is sent.",
				invitation_sent: 'The invitation with a new link to set the password has been sent by e-mail.',
				password_reset_sent: 'A password reset link has been sent by e-mail.',
				resend_failed: 'The e-mail could not be sent.',
				more_actions: 'More actions',
				set_password: 'Set password',
				password_set: 'The new password has been set.',
				reset_two_factor: 'Reset two-factor authentication',
				reset_two_factor_confirm:
					"Reset the two-factor authentication of '{name}'? They sign in with their password alone until they set it up again, unless a permission requires it - then they are asked to set it up at their next sign in.",
				two_factor_reset: 'The two-factor authentication has been reset.',
				lock: 'Lock',
				unlock: 'Unlock',
				lock_confirm: "Lock '{name}'? They can no longer sign in until unlocked.",
				unlock_confirm: "Unlock '{name}'? They can sign in again.",
			},
			settings: {
				legal_pages: {
					title: 'Legal pages',
					imprint: 'Imprint',
					privacy: 'Privacy policy',
					disclosure: 'Responsible disclosure',
					unsaved: 'Unsaved changes',
				},
				roles_and_permissions: {
					roles: 'Roles',
					permissions: 'Permissions',
					requires_two_factor: 'Requires two-factor authentication',
					requires_two_factor_text:
						'A user holding a permission marked here has to use two-factor authentication: without it they are made to set it up at their next sign in, and they cannot turn it off. Sign ins through Microsoft or Authentik are not affected.',
					requires_two_factor_saved: 'Saved - applies from the next sign in',
				},
				map: {
					general: 'General',
					preview: 'Preview',
					layer: 'Layers',
					overlays: 'Overlays',
				},
				webhook_incomings: {
					title: 'Incoming webhooks',
					info: 'Incoming webhooks accept HTTP requests from other services at the given API endpoint. The requests are logged and can be processed by a handler class.',
				},
				webhook_outgoings: {
					title: 'Outgoing webhooks',
					info: 'Outgoing webhooks send an HTTP request to the given URL when selected events occur. Sending happens in the background via the queue.',
				},
			},
			webhook_incoming_requests: {
				title: 'Incoming webhook requests',
			},
			webhook_outgoing_requests: {
				title: 'Outgoing webhook requests',
			},
		},
		legal: {
			back_to_login: 'Back to the login',
			load_failed: 'The text could not be loaded. Please try again later.',
		},
		me: {
			notifications: {
				title: 'Notifications',
				email: {
					title: 'E-mail',
					text: 'Activate or deactivate your e-mail notifications here.',
					activate: 'Activate e-mail notifications',
				},
				email_activate: 'Activate e-mail notifications',
				pushover: {
					title: 'Pushover',
					text: 'Use Pushover as a notification channel',
					activate: 'Activate the Pushover notification channel',
					user_key: 'Pushover user key',
				},
				telegram: {
					title: 'Telegram',
					text: 'Use Telegram as a notification channel',
					activate: 'Activate the Telegram notification channel',
					chat_id: 'Telegram chat ID',
				},
			},
			security: {
				title: 'Security',
				pat: {
					title: 'Private access tokens',
					text: 'Tokens for automations and scripts that call the API of the app.',
					text_mcp:
						'Tokens for automations and scripts that call the REST API, or for AI assistants such as Claude or Mistral through MCP.',
					forever: 'Unlimited',
					expired: 'Expired',
					never: 'Never',
				},
			},
		},
		profile: {
			firstname: 'First name',
			lastname: 'Last name',
			email: 'E-mail address',
			current_password: 'Current password',
			new_password: 'New password',
			password: 'Password',
			password_text: 'Ensure your account is using a long, random password to stay secure.',
			password_confirm: 'Confirm new password',
			profile_updated: 'Profile updated',
			password_updated: 'Password updated',
			avatar: 'Avatar',
			avatar_text: 'Set a custom avatar image for your profile.',
			profile: 'Profile',
			profile_text: "Update your account's profile information and e-mail address.",
			two_factor: 'Two-factor authentication',
			two_factor_text: 'On top of the password, signing in asks for a code from an authenticator app.',
		},
		auth: {
			login: {
				title: 'Please log into your account',
				text: 'Please enter your credentials.',
				email: 'E-mail address',
				password: 'Password',
				remember_me: 'Stay signed in',
				sign_in: 'Sign in',
				loading: 'Signing in...',
				register: {
					text: 'Not registered yet?',
					link: 'Register with e-mail',
				},
				password_reset: {
					link: 'Forgot your password?',
				},
				error: {
					invalid_login: 'Invalid e-mail address or password.',
					too_many_requests: 'Too many login attempts. Please try again later.',
					service_unavailable: 'Service currently unavailable. Please try again later.',
					invalid_two_factor_code: 'The code is not correct. Please enter the current code from the app.',
					sso_identity_conflict:
						'This e-mail address is already linked to another account at this provider. Please contact an administrator.',
					sso_rejected: 'The sign in could not be completed. Please contact an administrator.',
					sso_locked: 'Your account has been locked. Please contact an administrator.',
					sso_wrong_tenant: 'Accounts of this Microsoft organization cannot sign in here.',
					//notVerified: 'Your e-mail address has not been verified yet. Please use the link in the confirmation e-mail.',
					//ylocked: 'Your login has been deactivated. Please contact support@crewadmin.de',
				},
				two_factor: {
					title: 'Two-factor authentication',
					text: 'One more step: please enter the code from your authenticator app.',
					submit: 'Continue',
				},
				two_factor_setup: {
					title: 'Set up two-factor authentication',
					text: 'Your account requires two-factor authentication. Scan the QR code with an authenticator app and enter the first code it shows.',
				},
				social: {
					divider: 'or',
					google: 'Sign in with Google',
					microsoft: 'Sign in with Microsoft',
					apple: 'Sign in with Apple',
					keycloak: 'Sign in with Keycloak',
					authentik: 'Sign in with Authentik',
				},
				//resendVerification: 'Resend confirmation e-mail.',
			},
			register: {
				title: 'Create your account',
				text: 'Please enter your data.',
				firstname: 'First name',
				lastname: 'Last name',
				email: 'E-mail address',
				password: 'Password',
				confirm_password: 'Confirm password',
				accept_terms: 'I have read the <a href="{href}">privacy policy</a>.',
				sign_up: 'Register with e-mail',
				disabled: 'Registration is disabled',
				login: {
					text: 'Already have an account?',
					link: 'Sign in with e-mail or SSO',
				},
				error: {
					email_exists: 'This e-mail address is already registered.',
				},
				mail_taken: 'This e-mail address is already in use.',
				completed_text:
					'Please check your e-mail inbox. We have sent you an e-mail with instructions to sign in.',
			},
			password_reset: {
				title: 'Reset password',
				text: 'Please enter your e-mail address and we will send you instructions to reset your password.',
				email: 'E-mail address:',
				send_reset_link: 'Continue',
				completed_text:
					'Please check your e-mail inbox. We have sent you an e-mail with instructions to reset your password.',
			},
			new_password: {
				title: 'Reset password',
				text: 'Please enter a new password.',
				email: 'E-mail address:',
				new_password: 'New password:',
				confirm_password: 'Confirm new password:',
				set_new_password: 'Continue',
			},
			set_password: {
				title: 'Set your password',
				text: 'Welcome! Choose a password for your account.',
				email: 'E-mail address',
				password: 'Password',
				confirm_password: 'Confirm password',
				submit: 'Set password',
				done: 'Your password is set. You can now sign in with your e-mail address.',
				to_login: 'Go to sign in',
				invalid: 'This link has expired or was already used. Request a new one, it comes by e-mail.',
				request_new: 'Request a new link',
			},
		},
		settings: {
			general: {
				title: 'General',
			},
			users: {
				title: 'People',
			},
		},
		context: {
			settings: {
				title: 'Settings: {context} {name}',
				locked: '{context} is locked: changes are not possible right now.',
			},
		},
	},
	// Messages of the rules in utils/validations.ts. The key is the name the rule is given in the
	// field's `validations` prop.
	validations: {
		required: 'Input required',
		too_long: 'Input too long',
		too_short: 'Input too short',
		too_small: 'Value too small',
		too_large: 'Value too large',
		too_many_lines: 'Too many lines',
		line_too_long: 'Line too long',
		invalid_email: 'Invalid e-mail address',
		invalid_phone: 'Invalid phone number',
		invalid_url: 'Invalid address, must start with https://',
		invalid_zip: 'Invalid postal code',
		invalid_country: 'Two letter country code',
		mismatch: 'Inputs do not match',
		template_invalid: 'Invalid placeholder',
		not_member: 'No longer among the choices',
		not_event_member: 'Not all of them are among the choices any more',
	},
	sidebar: {
		home: 'Overview',
		blank: 'Blank',
		cards: 'Cards',
		graph: 'Graph',
		table: 'Table',
		users: 'People',
		settings: 'Settings',
		development: 'Development',
		swagger: 'Swagger UI',
		support: 'Support',
		maintenance: 'Maintenance',
	},
	components: {
		pwa_notify: {
			update: 'A new version is available',
			update_now: 'Update',
			offline_ready: 'The app now works without a connection too',
			offline: 'No connection',
			offline_text: 'Showing the last state.',
			online: 'Connected again',
		},
		save_footer: {
			save: 'Save',
			reset_all: 'Reset everything to the defaults',
			discard: 'Discard',
			unsaved: 'Unsaved changes',
			saved: 'All saved',
			shortcut: 'Save ({key})',
			confirm_title: 'Reset everything to the defaults?',
			confirm_text: 'Every field goes back to where it started. Nothing is stored until you save.',
		},
		template_editor: {
			groups: {
				data: 'Data',
				document: 'Document',
				general: 'General',
				self: 'This block',
				mail: 'Mail',
				regions: 'Regions',
			},
			// What a placeholder is, by its name and, failing that, by its last part; the editors fall back to these.
			placeholders: {
				general: {
					sender_name: 'Sender',
					ink_color: 'Heading colour',
					text_color: 'Text colour',
					muted_color: 'Muted colour',
					accent_color: 'Accent colour',
					font_family: 'Font',
					font_size: 'Font size',
					line_height: 'Line height',
					rule: 'Rule, as a CSS background',
					rule_height: 'Rule height',
					rule_color: 'Rule, as one colour',
					rule_px: 'Rule height in pixels',
					image_1_url: 'Image 1, as an image source',
					image_2_url: 'Image 2, as an image source',
					claim: 'Claim',
					addition_text: 'Additional text',
					has_contact_lines: 'There are contact lines',
					contact_lines: 'Contact lines',
					has_footer_columns: 'There are footer columns',
					footer_columns: 'Footer columns',
					footer_rows: 'Footer rows',
				},
				mail: {
					app_url: 'Address of the app',
					year: 'The current year',
					link_color: 'Link colour',
					primary_color: 'Button colour',
					success_color: 'Success colour',
					error_color: 'Error colour',
				},
				data: {
					document_title: 'What the document is, e.g. invoice',
					document_number: 'The number of the document',
					document_date: 'The date of the document',
					signature: 'The name the letter is signed with',
				},
				self: {
					addition: 'Addition',
					addition_url: 'Addition, as an image source',
					addition_is_text: 'Addition is text',
					addition_align: 'Alignment to the logo',
					addition_height: 'Height of the addition',
					addition_place: 'Place of the addition',
					align: 'Alignment',
					bleed: 'To the edge',
					card_background: 'Content background',
					card_border_color: 'Border colour',
					page_background: 'Page background',
					claim: 'Show the claim',
					claim_align: 'Place of the claim',
					claim_by_addition: 'Claim under the addition',
					color: 'Colour',
					columns: 'Columns',
					contact: 'Show the contact block',
					contact_bar: 'Bar at the contact block',
					contact_icons: 'Icons in the contact block',
					content_width: 'Content width',
					copyright: 'Copyright line',
					duplex: 'Two sided',
					punch_mark: 'Hole mark',
					fold_marks: 'Fold marks',
					folds: 'Where the fold marks sit',
					fold_top: 'First fold mark from the top',
					fold_height: 'Distance of the fold marks',
					top: 'Address field from the top',
					return_line: 'Return line',
					margin_left: 'Left margin',
					margin_right: 'Right margin',
					header_first_top: 'Head of page one from the top',
					header_follow_top: 'Head of later pages from the top',
					text_first_top: 'Text of page one from the top',
					text_follow_top: 'Text of later pages from the top',
					footer_first_bottom: 'Foot of page one from the bottom',
					footer_first_height: 'Foot height of page one',
					footer_follow_bottom: 'Foot of later pages from the bottom',
					footer_follow_height: 'Foot height of later pages',
					page_bottom_first: 'Bottom margin of page one',
					page_bottom_follow: 'Bottom margin of later pages',
					number_bottom_first: 'Page number of page one from the bottom',
					number_bottom_follow: 'Page number of later pages from the bottom',
					height: 'Height',
					width: 'Width',
					image: 'Graphic',
					image_url: 'Graphic, as an image source',
					layout: 'Layout',
					logo: 'Logo',
					logo_url: 'Logo, as an image source',
					logo_is_text: 'Logo is text',
					logo_height: 'Logo height',
					logo_offset: 'Logo offset',
					logo_width: 'Logo width',
					rows: 'Rows',
					rule: 'Show the rule',
				},
				content: 'The content of the mail',
				header: 'The head',
				footer: 'The foot',
				header_bleed: 'The head reaches the edge',
				footer_bleed: 'The foot reaches the edge',
				icon: 'Icon',
				text: 'Text',
				title: 'Heading',
				lines: 'Lines',
				items: 'Entries',
				label: 'Label',
				value: 'Value',
			},
			variables: 'Placeholders',
			insert: 'Insert at the cursor, around a selection',
			field_hint: 'Only available inside {section}',
			search: 'Search placeholders',
			none_found: 'No placeholder matches.',
			kinds: {
				text: 'Texts',
				html: 'HTML',
				list: 'Lists',
				flag: 'Conditions',
			},
			languages: {
				text: 'Text',
				html: 'HTML',
				css: 'CSS',
				json: 'JSON',
			},
			issues: {
				syntax: 'A section is not closed or wrongly nested',
				unknown: 'Unknown placeholder: {name}',
				not_printable: '{name} is a list or a switch and only usable as a section',
				unsupported: 'This tag is not supported: {name}',
			},
		},
		letterhead_editor: {
			settings: 'Letterhead settings',
			preview: 'Letterhead preview',
			title: 'Letterhead',
			saved: 'Letterhead saved',
			overrides_disabled: 'Own letterheads are switched off in this app.',
			no_image: 'No image',
			popup_blocked: 'The browser blocked the new window. Please allow pop-ups for this site.',
			duplex: {
				title: 'Two sided',
				text: 'For printing on both sides: the first margin is the inner one at the binding, the second the outer one. The even pages are mirrored, with head, foot and page number. The hole mark is then on the front pages only.',
			},
			fold_marks: {
				title: 'Fold marks',
				text: 'Two short lines in the left margin of page one after DIN 5008, where the letter is folded for a window envelope. The form of the address field decides where they sit: form A at 87 and 192 mm, form B at 105 and 210 mm. Without an address field there are none.',
			},
			address_top: {
				title: 'Address field from the top',
				text: 'Where the address field starts, in millimetres from the top of the paper; the form sets the DIN 5008 value. The text of page one starts below it.',
			},
			text_first_top: {
				title: 'Text from the top',
				text: 'Where the text of page one starts while there is no address field. With one, the address field sets it.',
			},
			punch_mark: {
				title: 'Hole mark',
				text: 'A short line in the left margin at half the height (148.5 mm), after DIN 5008. It shows where to punch, on every page of the letter.',
			},
			text_top: {
				title: 'Text from the top',
				text: 'Where the letter starts on this page, in millimetres from the top edge of the paper. It belongs below the head.',
			},
			footer_height: {
				title: 'Foot height',
				text: 'How tall the foot is. The letter ends this far above "Foot from the bottom".',
			},
			contact_lines_hint: 'One Font Awesome name per line, e.g. phone. Texts and placeholders spanning several lines become several lines.',
			empty_row: 'Empty line',
			samples: {
				label: 'Sample',
				one_page: 'Letter, 1 page',
				two_pages: 'Draft, 2 pages',
				table: 'Table over 2 pages',
			},
			blocks: {
				skeleton: 'Skeleton',
				header_first: 'Head of page one',
				header_follow: 'Head of later pages',
				address: 'Address field',
				footer_first: 'Foot of page one',
				footer_follow: 'Foot of later pages',
			},
			css_hints: {
				skeleton: 'The page\'s CSS: the margins and where head, text and foot sit. The values of the JSON above are self.margin_left and so on here. The address field stays the address block\'s.',
				address: 'The CSS of the address field and its fold marks; the values of the JSON above are self.top and so on here.',
			},
			return_line_hint: 'The small line over the address that shows in a window envelope. A pattern with placeholders, e.g. for the office address: every letter takes it over when drafted and can still change it. Left empty, every letter brings its own line.',
			content_sections: {
				header: 'Header',
				footer: 'Footer',
			},
			layouts: {
				'logo-left': 'Logo left',
				'logo-right': 'Logo right',
				centered: 'Centred',
			},
			addition_places: {
				logo: 'By the logo',
				center: 'Centred',
				info: 'By the contact block',
			},
			addition_aligns: {
				top: 'Top',
				middle: 'Middle',
				bottom: 'Bottom',
			},
			addition_hint: {
				title: 'Addition',
				text: 'By the logo: it stands right beside the logo. Centred: centred between the logo and the contact block. By the contact block: flush against the contact block. The alignment says whether it lines up with the top, middle or bottom of the logo.',
			},
			lockup: {
				image_1: 'Image 1',
				image_2: 'Image 2',
				text: 'Text',
				none: 'Nothing',
			},
			aligns: {
				left: 'Left',
				center: 'Centre',
				right: 'Right',
			},
			logo_offset: {
				title: 'Offset',
				text: 'A negative value moves the logo and its addition into the left page margin together.',
			},
			rule_background: {
				title: 'Rule',
				text: 'A CSS background: a colour, a gradient such as linear-gradient(90deg, #9ead41, #e35d26), or none.',
			},
			placeholder_hints: {
				document_title: 'What the document is, e.g. Invoice',
				document_number: 'The number of the document',
				document_date: 'The date of the document',
				image_1_url: 'Image 1, as an image source',
				image_2_url: 'Image 2, as an image source',
				ink_color: 'The colour of the headings',
				text_color: 'The text colour',
				muted_color: 'The muted colour',
				accent_color: 'The accent colour',
				signature: 'The name the letter is signed with',
			},
			sample: {
				return_line: 'Sample Ltd · 1 Sample Street · 12345 Sampletown',
				watermark: 'Draft',
				recipient: 'Example Law Firm\nMr Max Mustermann\n7 Example Road\n54321 Exampletown',
				subject_label: 'Subject:',
				subject: 'A sample letter',
				salutation: 'Dear Mr Mustermann,',
				body: 'this is a sample text. It shows how a letter looks on this letterhead: where the text starts, how it wraps and where head and foot sit.\n\nThe second paragraph shows the space between paragraphs.',
				closing: 'Kind regards',
				signature: 'Erika Musterfrau',
				table_position: 'No.',
				table_item: 'Item',
				table_amount: 'Amount',
				table_row: 'Sample item {n}',
				table_total: 'Total',
				table_intro: 'please find the list of items below. The table runs past the page; on the second page its head appears again.',
				paragraphs: [
					'In this part of the sample the letter runs onto the next page. There it carries the head of the later pages, and the page number sits at the bottom. This shows whether the text keeps enough distance to head and foot.',
					'A paragraph is never cut inside a line, but it may be cut between two lines. Where exactly the page ends depends on the page geometry set in the skeleton, and on type size and leading.',
					'Longer letters, such as a detailed account of a line of succession or a list of documents, run across several pages this way. Every page after the first starts where the later pages are set to start.',
				],
			},
			closing: 'Closing',
			closing_hint: 'Stands under the text of every letter, lines and blank lines as written: the blank lines leave room for the signature, the placeholder for the signer puts the name under it. Left empty, every letter brings its own closing.',
		},
		letterhead_sheet: {
			loading: 'Preparing the letter ...',
			title: 'Letter',
			page_of: 'Page {page} of {total}',
			pages: '{n} page | {n} pages',
		},
		// Toolbar of the GanttChart timeline component
		gantt: {
			day: 'Day',
			week: 'Week',
			month: 'Month',
			today: 'Today',
			label_header: 'Task',
			empty: 'No entries',
			collapse_labels: 'Collapse column',
			expand_all: 'Expand all',
			collapse_all: 'Collapse all',
			expand_labels: 'Expand column',
			allowed_range: 'Can be moved between {from} and {to}',
			depends_after: 'Starts after {label}',
			depends_together: 'Starts together with {label}',
		},
		schedule_period_bar: {
			from: 'From',
			to: 'Until',
			current_quarter: 'This quarter',
			current_month: 'This month',
			current_year: 'This year',
			previous_period: 'Previous period',
			next_period: 'Next period',
		},
		// efDropArea
		drop_area: {
			hint: 'Drop files here',
			browse: 'or click to choose them',
			uploading: 'Uploading...',
			too_large: 'Too large - at most {size}',
			retry: 'Retry one file | Retry {n} files',
			clear: 'Clear list',
		},
		// efSourceEditor, the frame of efMarkdownEditor and efHtmlEditor
		source_editor: {
			write: 'Edit',
			preview: 'Preview',
			split: 'Edit & preview',
			empty: 'Nothing to preview yet.',
		},
		// efHtmlEditor
		html_editor: {
			hint: 'Written in HTML, style elements included. The preview shows the page as it will look.',
			placeholder_text: 'text',
			placeholder_link: 'link text',
			toolbar: {
				bold: 'Bold',
				italic: 'Italic',
				heading: 'Heading',
				paragraph: 'Paragraph',
				bullet_list: 'Bulleted list',
				numbered_list: 'Numbered list',
				link: 'Link',
			},
		},
		// efMarkdownEditor
		markdown_editor: {
			hint: 'Formatted with Markdown. The toolbar inserts the marks for you.',
			placeholder_text: 'text',
			placeholder_link: 'link text',
			placeholder_column: 'column',
			toolbar: {
				bold: 'Bold',
				italic: 'Italic',
				strikethrough: 'Strikethrough',
				heading: 'Heading',
				bullet_list: 'Bulleted list',
				numbered_list: 'Numbered list',
				quote: 'Quote',
				link: 'Link',
				table: 'Table',
			},
		},
		color_input: {
			unset: 'Not set - the inherited value is used',
			presets: 'Suggested colours',
		},
		two_factor: {
			enabled: 'Active',
			disabled: 'Not active',
			enabled_text: 'Signing in asks for a code from your authenticator app after the password.',
			disabled_text:
				'Without a second factor your password alone signs you in. Turning it on needs an authenticator app on your phone.',
			since: 'Active since {date}',
			activate: 'Enable two-factor authentication',
			deactivate: 'Disable two-factor authentication',
			activated: 'Two-factor authentication enabled',
			deactivated: 'Two-factor authentication disabled',
			required: 'Required',
			required_text: 'Your permissions require two-factor authentication, so it cannot be turned off.',
			required_missing_text:
				'Your permissions require two-factor authentication. Please enable it now - otherwise you will be asked to set it up at your next sign in.',
			code: 'Verification code',
			secret: 'Or enter this key manually',
			copy: 'Copy to clipboard',
			copied: 'Key copied',
		},
		mail_theme: {
			settings: 'Mail design settings',
			title: 'Mail design',
			popover: {
				title: 'Mail design',
				text: 'Colours, logo and the HTML blocks every mail is built from.',
			},
			overrides_disabled: 'Own designs are not enabled for this app.',
			regions: {
				content: 'The content of the mail',
				header: 'The header region',
				footer: 'The footer region',
			},
			samples: {
				label: 'Sample mail',
				action: 'With a button',
				list: 'With a list',
			},
			viewports: {
				label: 'Width of the preview',
				desktop: 'Desktop',
				mobile: 'Phone',
			},
			preview_title: 'Preview',
			saved: 'Mail design saved',
			groups: {
				links: 'Colours',
				images: 'Images',
			},
			blocks: {
				skeleton: 'Skeleton',
				header: 'Head',
				footer: 'Foot',
			},
			skeleton_hint: 'The frame of the mail around its content. content, header and footer put in the message, the header and the footer; the values of the JSON above are self.page_background and so on.',
			copyright_hint: 'The line under the mail, with placeholders such as the year or the sender. Empty leaves it out.',
			embed_images: {
				title: 'Embed images',
				text: 'The design\'s logo, images and graphics travel inside the mail (CID) instead of being loaded when it is opened. Classic Outlook and Gmail show them without asking; the mail grows by the images, some clients also list them as attachments. The preview here still links them, the test mail embeds them.',
			},
			block_color: {
				title: 'Colour',
				text: 'Empty, the colour from the General tab.',
			},
			closing: 'Closing',
			closing_hint: 'Stands under every mail that brings none of its own, lines as written, with placeholders such as the sender. Empty leaves it out.',
		},
		document_view: {
			pdf_failed: 'The PDF could not be created.',
		},
		text_templates: {
			title: 'Text templates',
			hint_app: 'The texts the documents and mails are written from. Empty fields use the app\'s default.',
			overrides_disabled: 'Own texts are not enabled for this app.',
			preview: 'With example values',
			saved: 'Text templates saved',
		},
		branding_editor: {
			title: 'Sender & style',
			settings: 'Shared settings of mail and letterhead',
			preview: 'Preview',
			header_hint: 'Which of it a head shows is set by its design under Mail or Letterhead; a mail shows the claim.',
			sender: 'Sender',
			sender_name_hint: {
				title: 'Sender',
				text: 'The title of a mail, the alt text of its logo and the name under the greeting. Empty, the app\'s name.',
			},
			type: 'Type and colours',
			type_hint_mail: 'The size in pt, a mail draws it in px (10.5 pt is 14 px). A mail loads no font files and takes the first family of the stack the mail program knows.',
			type_hint: 'For the letter and the mail. The size in pt is the letter\'s, a mail draws it in px (10.5 pt is 14 px); a mail loads no font files and takes the next family of the stack. These fonts travel with every letter:',
			accents: 'Accents',
			contact: 'Contact block',
			footer: 'Footer',
			css: 'Custom CSS',
			css_hint_mail: 'Applies to the mail, which inlines what matches. general.fieldname puts in the values above. Classes:',
			css_hint: 'Applies to the letter and the mail; in the letter on the sheet only. general.fieldname puts in the values above. Classes:',
			rule: 'Rule',
			rule_hint_mail: 'The rule under the head and over the foot of the mail. The mail draws its thickness in pixels, 1.3 mm is 5 px.',
			rule_hint: 'The rule under the head and over the foot, on the letter as in the mail. The mail draws its thickness in pixels, 1.3 mm is 5 px.',
			overrides_disabled: 'An own design is not enabled for this app.',
			saved: 'Design saved',
			media: {
				label: 'Preview as',
				letter: 'Letter',
				mail: 'Mail',
			},
		},
		design_editor: {
			parts: {
				branding: 'General',
				mail: 'Mail',
				letterhead: 'Letterhead',
			},
		},
		own_design: {
			label: 'Own design',
			on: 'Uses a design of its own. Changes to the admin design no longer reach it.',
			off: 'Uses the admin design. Switched on, the own design starts as a copy of it.',
			adopt_title: 'Take the admin design again?',
			adopt_text: 'Everything set here is replaced by the current admin design. It is saved at once.',
		},
		block_editor: {
			designs: {
				din5008: 'DIN 5008',
				card: 'Card',
				sheet: 'Sheet',
				lockup: 'Logo with contact block',
				din5008_a: 'DIN 5008 form A, small head',
				din5008_b: 'DIN 5008 form B, large head',
				columns: 'Columns and lines',
				logo: 'Logo and claim',
				html: 'Own HTML',
				none: 'None',
				image: 'Image',
				same: 'As on page one',
			},
			as_html_hint: 'Copies the chosen design into this block as HTML, as the start of a design of its own. Its settings come along as JSON.',
			same_hint: 'The later pages show the same block as page one.',
			bleed: {
				title: 'To the edge',
				text: 'In a letter the image reaches the edge of the paper, a header also the top, a footer the bottom. In a mail on the sheet the card\'s padding goes, so the graphic frames the card.',
			},
			json_hint: 'The values of the block. In the HTML below they are self.fieldname, the general ones general.fieldname.',
			json_invalid: 'No valid JSON object; the last valid values still apply.',
		},
		sender: {
			images_hint: 'PNG, JPG, WebP, GIF or SVG up to 2 MB. An SVG gets a PNG of itself on upload for the mails, as Gmail and Outlook show no SVG there; Outlook for Windows shows no WebP either.',
			upload_failed: 'The image could not be uploaded.',
		},
		select_user: {
			placeholder: 'Select person...',
		},
		file_upload: {
			too_large: 'File is too large — at most {size}',
			drop_here: 'Drop a file here | Drop files here',
		},
		// Controls of efTimeChart: the window the plot is scaled to, the way through the years
		// beside it, and the labels drawn into the plot itself
		time_chart: {
			range: 'Range',
			range_years: '{years} years',
			range_years_hint: 'The next {years} years, with the history before them',
			range_full: 'Full range',
			range_full_hint: 'The whole timeline',
			previous: 'Earlier',
			next: 'Later',
			reset: 'Back to today',
			today: 'today',
			series: 'Series',
			markers: 'Annotations',
		},
		ef_row_count: {
			page: 'Page {current} of {total}',
			rows: 'Entries {from} to {to} of {total}',
			filtered: '(filtered from {total})',
			none: 'No entries',
		},
		ef_table: {
			elements_per_page: 'Entries per page',
			no_elements: 'No entries',
			sort_by: 'Sort by',
			sort_default: 'Default order',
		},
		ef_import_wizard: {
			title: 'Import',
			run: 'Start import',
			preview_failed: 'The preview could not be generated.',
			apply_failed: 'The import could not be completed.',
			step: {
				file: 'File',
				mapping: 'Mapping',
				preview: 'Preview',
			},
			file: {
				hint: 'Excel or CSV file with one record per row. The first row must contain the column headers.',
				sheet: 'Sheet',
				parsed: 'Read {rows} rows with {columns} columns.',
				too_many_rows: 'The file has more than {max} rows. Please split it into several files.',
				error: 'The file could not be read.',
			},
			mapping: {
				hint: 'The mapping was guessed from the headers. Please check and correct it if needed.',
				none: '– do not map –',
				column: 'Column {index}',
			},
			report: {
				preview: 'Preview – nothing has been saved yet.',
				applied: 'Import completed',
				line: 'Row',
				result: 'Result',
			},
			action: {
				create: 'new',
				update: 'updated',
				attach: 'linked',
				detach: 'unlinked',
				delete: 'deleted',
				skipped: 'skipped',
				unchanged: 'unchanged',
			},
			summary: {
				rows: 'Rows',
				skipped: 'Skipped',
				warnings: 'Warnings',
			},
			error: {
				missing_external_id: 'No unique ID',
				duplicate_external_id: 'Duplicate ID',
				missing_name: 'No name',
			},
		},
		header_notification: {
			new_notifications: 'No notifications | One notification | {count} notifications',
			view_all: 'View all',
		},
		header_profile: {
			profile: 'Profile',
			settings: 'Settings',
			dark_mode: 'Dark',
			light_mode: 'Light',
			auto_mode: 'Auto',
			theme: 'Theme',
			notifications: 'Notifications',
			reverb_ping: 'Check realtime connection',
			sign_out: 'Sign out',
		},
		header_profile_i18n: {
			locale: {
				en: 'English',
				de: 'German',
			},
		},
		header_search: {
			placeholder: 'Search...',
		},
		sidebar: {
			support: {
				subject: '[{app_title}] Support request',
				body: `Hello {app_title} team,

I need support on the page '{uri}'.

Short description:
...

Priority/Affected:
- Priority: (blocker/high/medium/low)
- Affected: (e.g. only me / team / all users)

Expected behavior:
...

Actual behavior:
...

Steps to reproduce:
1) ...
2) ...
3) ...

Environment:
- Browser: ...
- Operating system: ...

Time:
- since: ...
- last observed: ...

Error message / logs:
- ...

You can reach me for questions at: ...

Thank you for your support



Additional data:
{data}
`,
			},
		},
		vertical_tabs: {
			unsaved: 'Unsaved changes',
		},
		header_context: {
			search: 'Search',
			at: 'At {name}',
			own: 'Your others',
			others: 'More you have access to',
			with: 'with {name}',
			nothing_found: 'Nothing found',
			switched: '{context} switched',
			locked: 'Locked',
			unplaced: 'No {context} yet',
			set_up: 'Set up',
		},
	},
	// Generic strings of the import module. Everything specific to one import (field labels,
	// subjects, its own error codes) lives in the app under the wizard's i18nPrefix and wins
	// over the keys below.
	filters: {
		status: 'Status',
		role: 'Role',
		user: 'Responsible person',
	},
	modals: {
		me: {
			create_token: {
				title: 'Create new token',
				kind: 'Use',
				endpoint: 'Endpoint',
				kind_hint_pat: 'For automations and scripts. Works on the REST API, not on the MCP server.',
				kind_hint_mcp: 'For AI assistants such as Claude. Works on the MCP server only, not on the REST API.',
				expiry: 'Validity',
				expiry_1d: '1 day',
				expiry_1m: '1 month',
				expiry_3m: '3 months',
				expiry_1y: '1 year',
				expiry_forever: 'Unlimited',
				scope: 'Permissions',
				scope_full: 'All own',
				scope_limited: 'Selected',
				scope_hint: 'Revoked permissions are revoked for the token.',
				scope_global: 'Global',
				scope_count: '{count} selected',
				scope_none: 'Select at least one permission.',
			},
			two_factor_setup: {
				title: 'Set up two-factor authentication',
				text: 'Scan the QR code with an authenticator app, for example Microsoft Authenticator, Google Authenticator or 1Password.',
				hint: 'The key is shown this one time only. Two-factor authentication is not active until the first code is confirmed.',
				activate: 'Activate',
			},
			two_factor_disable: {
				title: 'Disable two-factor authentication',
				text: 'Your password alone will sign you in afterwards. Please enter your current password to confirm.',
			},
			show_token: {
				title: 'Token created',
				text: 'Copy the token now – for security reasons it is only shown this one time.',
				copy: 'Copy to clipboard',
				copied: 'Token copied',
				mcp_url: 'Address of the MCP server',
				mcp_url_copied: 'Address copied',
			},
		},
		confirm: {
			remove_announcement: 'Remove announcement',
			remove_announcement_title: `Remove the announcement "{title}"?`,
		},
		admin: {
			edit_user: {
				create: 'Invite new person',
				edit: 'Edit person',
				sso_identities: 'Linked sign in accounts',
				sso_subject: 'Account ID',
				sso_last_login: 'Last login',
				sso_groups: 'Groups',
				sso_unlink: 'Unlink account',
				sso_unlink_confirm:
					'Unlink the {provider} account? The next sign in through {provider} links the account with the same e-mail address again.',
			},
			set_user_password: {
				title: 'Set password',
				text: 'The person signs in with this password from now on. Tell it to them on a secure channel.',
				password: 'New password',
				confirmation: 'Repeat new password',
				save: 'Set password',
			},
			remove_user: {
				title: 'Remove person',
				reasons: 'Reasons',
				mode: {
					delete: 'The person can be deleted.',
					anonymize_only: 'The person can only be anonymized, because data still refers to them.',
					blocked: 'The person can currently be neither deleted nor anonymized.',
				},
				delete_info: 'Deleting removes the person and all their data for good.',
				anonymize_info:
					'Anonymizing keeps the record for teams, events and payroll, but removes name, email, logins and all personal data. The person can no longer log in afterwards.',
				confirm: "Type '{name}' to confirm",
				delete: 'Delete for good',
				anonymize: 'Anonymize',
				deleted: 'The person was deleted.',
				anonymized: 'The person was anonymized.',
				failed: 'The action is not allowed or failed. The reasons have been updated.',
				load_failed: 'Could not determine whether the person can be removed.',
				confirm_label: 'Name to confirm',
			},
			edit_role: {
				create: 'Create new role',
				edit: 'Edit role',
				permissions: 'Permissions',
			},
			edit_webhook_incoming: {
				create: 'Create new webhook',
				edit: 'Edit webhook',
				auth_none: 'None',
				auth_basic: 'HTTP Basic',
				auth_token: 'Query token',
				webhook_url: 'Webhook URL',
				headers: 'Headers',
				cleanup_enabled: 'Automatically delete successful requests after 7 days',
				remote_settings: 'Settings for the sending application',
				no_handlers: 'No webhook handler classes are available in this application.',
			},
			edit_webhook_outgoing: {
				create: 'Create new outgoing webhook',
				edit: 'Edit outgoing webhook',
				payload: 'Payload (request body)',
				payload_hint: 'If left empty, all available data of the event is sent as JSON.',
				placeholders: 'Available placeholders',
				placeholders_hint: 'Click a placeholder to insert it into the payload.',
				cleanup_enabled: 'Automatically delete successful requests after 7 days',
			},
			delete_role: {
				title: 'Delete role',
				text: "Do you really want to delete the role '{item}'?",
			},
			edit_context_role: {
				create: 'Create new context role',
				edit: 'Edit context role',
				permissions: 'Permissions',
			},
			delete_context_role: {
				title: 'Delete context role',
				text: "Do you really want to delete the context-based role '{item}'?",
			},
		},
		image_upload: {
			resize_error: 'The image could not be processed.',
			select_image_file: 'Please select an image file.',
		},
		delete_article_image: {
			title: 'Delete image',
			text: 'Do you really want to delete the article image?',
		},
		show_location: {
			orders: 'Orders',
			cart_items: 'Order items',
		},
		table_column_filter: {
			title: 'Table column filter',
			name: 'Name',
			show: 'Show',
		},
	},
	confirms: {
		delete_webhook_incoming: {
			title: 'Delete incoming webhook',
			text: 'Do you really want to delete the webhook "{item}"? All associated webhook requests will be deleted as well.',
		},
		delete_webhook_incoming_request: {
			title: 'Delete webhook request',
			text: 'Do you really want to delete this webhook request?',
		},
		delete_webhook_outgoing: {
			title: 'Delete outgoing webhook',
			text: 'Do you really want to delete the outgoing webhook "{item}"? All associated webhook requests will be deleted as well.',
		},
		delete_webhook_outgoing_request: {
			title: 'Delete webhook request',
			text: 'Do you really want to delete this webhook request?',
		},
		replay_webhook_outgoing_request: {
			title: 'Resend webhook',
			text: 'Do you really want to resend this request with the stored event data? The body is regenerated using the current payload template and the current URL of the webhook.',
		},
		revoke_token: {
			title: 'Revoke token',
			text: 'Do you really want to revoke the token "{item}"? Applications using this token will lose access immediately.',
		},
		delete_failed_job: {
			title: 'Delete failed job',
			text: 'Do you really want to delete the failed job "{item}"? It cannot be retried afterwards.',
		},
		delete_all_failed_jobs: {
			title: 'Delete all failed jobs',
			text: 'Do you really want to delete all {count} failed jobs? They cannot be retried afterwards.',
		},
		clear_mail_log: {
			title: 'Clear mail log',
			text: 'Do you really want to delete the counters for sent and failed mails together with the recorded failures? The Prometheus metrics are kept.',
		},
		wipe_metrics: {
			title: 'Reset metrics',
			text: 'Do you really want to reset all recorded metrics of this instance? Data already scraped by the Prometheus server is kept.',
		},
		leave_unsaved: {
			title: 'Discard unsaved changes?',
			text: 'The tab {tabs} has unsaved changes. If you leave the page, they are lost. | The tabs {tabs} have unsaved changes. If you leave the page, they are lost.',
		},
	},
	data: {
		letterhead_editor: {
			sender_name: 'Sender',
			addition_text: 'Addition text',
			return_line: 'Return line',
			claim: 'Claim',
			contact_lines: 'Contact block',
			icon: 'Icon',
			text: 'Text',
			columns: 'Columns',
			column_title: 'Heading',
			column_text: 'Lines',
			rows: 'Lines under the columns',
			label: 'Label',
			value: 'Value',
			layout: 'Layout',
			logo_height: 'Logo height',
			logo_offset: 'Logo offset',
			logo: 'Logo',
			addition: 'Addition',
			addition_height: 'Addition height',
			addition_size: 'Addition type size',
			addition_place: 'Addition place',
			addition_align: 'Alignment to the logo',
			footer_columns: 'Columns',
			footer_rows: 'Lines under them',
			footer_rule: 'Rule',
			claim_align: 'Claim',
			claim_by_addition: 'Claim under the addition',
			contact: 'Contact block',
			contact_bar: 'Bar beside the contact block',
			contact_icons: 'Icons in the contact block',
			rule: 'Rule',
			align: 'Alignment',
			address_top: 'Address field from the top',
			image_1_url: 'Image 1',
			image_2_url: 'Image 2',
			font_family: 'Font',
			font_size: 'Font size',
			line_height: 'Line height',
			ink_color: 'Headings',
			text_color: 'Text',
			muted_color: 'Muted',
			accent_color: 'Accent',
			rule_background: 'Rule',
			rule_height: 'Rule height',
			margin_left: 'Left margin',
			margin_right: 'Right margin',
			margin_inner: 'Inner margin',
			margin_outer: 'Outer margin',
			duplex: 'Two sided',
			fold_marks: 'Fold marks',
			punch_mark: 'Hole mark',
			header_first_top: 'Head from the top, page one',
			text_first_top: 'Text from the top, page one',
			header_follow_top: 'Head from the top, later pages',
			text_follow_top: 'Text from the top, later pages',
			footer_first_bottom: 'Foot from the bottom, page one',
			footer_first_height: 'Foot height, page one',
			footer_follow_bottom: 'Foot from the bottom, later pages',
			footer_follow_height: 'Foot height, later pages',
			custom_css: 'CSS',
			closing: 'Closing',
		},
		block_editor: {
			design: 'Design',
			html: 'Own HTML',
			css: 'Own CSS',
			settings: 'Values (JSON)',
			image_height: 'Height',
			image_width: 'Width',
			bleed: 'To the edge',
		},
		mail_theme: {
			content_width: 'Content width',
			embed_images: 'Embed images in the mail',
			copyright: 'Copyright',
			font_family: 'Font family',
			page_background: 'Page background',
			card_background: 'Card background',
			card_border_color: 'Border colour',
			text_color: 'Text colour',
			link_color: 'Link colour',
			primary_color: 'Primary colour',
			success_color: 'Success colour',
			error_color: 'Error colour',
			header_rule: 'Rule under the head',
			footer_rule: 'Rule over the foot',
			ink_color: 'Heading colour',
			muted_color: 'Muted colour',
			accent_color: 'Accent colour',
			rule: 'Rule',
			rule_height: 'Rule thickness',
			rule_color: 'The rule\'s colour without a gradient',
			rule_px: 'The rule\'s thickness in pixels',
			header_color: 'Header colour',
			sender_name: 'Sender name',
			image_1_url: 'Image 1, as an image source',
			image_2_url: 'Image 2, as an image source',
			claim: 'The claim',
			addition_text: 'The addition to the logo',
			has_footer_columns: 'Whether the footer has columns',
			footer_columns: 'The columns of the footer',
			footer_rows: 'The lines under the columns',
			items: 'The entries of a line',
			title: 'The title of the column',
			text: 'The text of the column',
			label: 'The label',
			value: 'The value',
			app_url: 'The address of the app',
			logo_width: 'Logo width',
			footer_text: 'Footer text',
			footer_color: 'Footer colour',
			custom_css: 'Additional CSS',
			closing: 'Closing',
		},
		personal_access_token: {
			id: 'Id',
			name: 'Name',
			kind: 'Use',
			kind_pat: 'REST API',
			kind_mcp: 'MCP',
			abilities: 'Permissions',
			abilities_full: 'All',
			abilities_lost: 'revoked',
			expires_at: 'Expires',
			last_used_at: 'Last used',
			created_at: 'Created',
		},
		user: {
			id: 'Id',
			firstname: 'First name',
			lastname: 'Last name',
			avatar: 'Avatar',
			labels: 'Label',
			email: 'E-mail address',
			role: 'Role',
			roles: 'Roles',
			context_role: 'Role',
			context_roles: 'Roles',
			createdAt: 'Created at',
			last_user_login: 'Last login',
		},
		role: {
			id: 'Id',
			name: 'Name',
			guard_name: 'Guard',
			description: 'Description',
			permissions: 'Permissions',
		},
		permission: {
			id: 'Id',
			name: 'Name',
			guard_name: 'Guard',
			description: 'Description',
			requires_two_factor: 'Requires 2FA',
		},
		config: {
			card: 'Settings',
			key: 'Key',
			public: 'Public',
			type: 'Type',
			default: 'Default',
			value: 'Value',
			setting: 'Setting',
			keys: {
				app: {
					name: {
						label: 'App name',
						help: 'Shown in the header and the sidebar.',
					},
					short_name: {
						label: 'Short name',
						help: 'Replaces the name in the header on narrow screens.',
					},
					primary_color: {
						label: 'Primary colour',
						help: 'Buttons, links and active elements. Text on it turns white or dark, whichever reads better.',
					},
					secondary_color: {
						label: 'Secondary colour',
						help: 'Secondary buttons and muted elements.',
					},
					operator_name: {
						label: 'Operator',
						help: 'Shown in the footer of the login page, next to the links to the legal pages.',
					},
					operator_url: {
						label: 'Operator website',
						help: 'The operator name links here. Left empty, it links to etherforce.net.',
					},
					show_applications: {
						label: 'Show other applications',
						help: 'Shows the switcher to the other applications in the header.',
					},
				},
				auth: {
					invitation_expire_days: {
						label: 'Invitation valid for',
						help: 'How long the link stays valid that a new account sets its password with.',
						unit: 'days',
					},
				},
			},
		},
		webhook_incoming: {
			id: 'Id',
			name: 'Name',
			class: 'Class',
			endpoint: 'API endpoint',
			auth_type: 'Authentication',
			client_id: 'Username',
			client_secret: 'Password',
			token: 'Token',
			requests_count: '# Requests',
		},
		webhook_incoming_request: {
			service_id: 'Service',
			action: 'Action',
			ip_address: 'IP',
			dns: 'DNS',
			method: 'Method',
			created_at: 'Time',
			payload: 'Payload',
			data: 'Data',
			success: 'Status',
		},
		webhook_outgoing: {
			id: 'Id',
			name: 'Name',
			event_class: 'Event',
			url: 'URL',
			method: 'Method',
			enabled: 'Enabled',
			requests_count: '# Requests',
			last_triggered_at: 'Last triggered',
		},
		webhook_outgoing_request: {
			id: 'Id',
			created_at: 'Time',
			event_class: 'Event',
			url: 'URL',
			method: 'Method',
			attempt: 'Attempt',
			status_code: 'Status code',
			state: 'Result',
		},
	},
	tabs: {
		admin_settings: {
			legal_pages: 'Legal pages',
			mail_theme: 'Mail design',
			design: 'Sender & style',
			roles_and_permissions: 'Roles & permissions',
			webhook_incomings: 'Incoming webhooks',
			webhook_outgoings: 'Outgoing webhooks',
			settings: 'Settings',
			groups: {
				access: 'Access',
				appearance: 'Appearance',
				communication: 'Communication',
				integrations: 'Integrations',
				system: 'System',
			},
			letterhead: 'Letterhead',
		},
		development: {
			tools: 'Tools',
			stores: 'Stores',
			authentication: 'Authentication',
			select: 'Select components',
			php_info: 'PHP info',
			images: 'Images',
			media_store: 'S3 storage',
			influx_store: 'InfluxDB',
			db_store: 'Database',
			redis_store: 'Redis',
			queue_store: 'Queue',
			mail_store: 'Mail',
			pdf_renderer: 'PDF renderer',
			metrics_store: 'Metrics',
		},
		me: {
			general: 'General',
			notifications: 'Notifications',
			security: 'Security',
		},
		context_settings: {
			groups: {
				general: 'General',
				members: 'Members',
				appearance: 'Appearance',
				communication: 'Communication',
				integrations: 'Integrations',
			},
			design: 'Mail & letterhead design',
		},
	},
	popovers: {
		event: {
			preferred_crs: {
				title: 'Preferred coordinate system',
				text: 'Coordinate system selected by default for this event.',
			},
		},
	},
	enums: {
		boolean: {
			true: 'Yes',
			false: 'No',
		},
		transformation_input_methode: {
			manual: 'Direct input',
			reference: 'Reference points',
		},
		month_names: {
			undefined: '',
			0: 'January',
			1: 'February',
			2: 'March',
			3: 'April',
			4: 'May',
			5: 'June',
			6: 'July',
			7: 'August',
			8: 'September',
			9: 'October',
			10: 'November',
			11: 'December',
		},
		day_names: {
			0: 'Sunday',
			1: 'Monday',
			2: 'Tuesday',
			3: 'Wednesday',
			4: 'Thursday',
			5: 'Friday',
			6: 'Saturday',
		},
		day_short_names: {
			0: 'Sun',
			1: 'Mon',
			2: 'Tue',
			3: 'Wed',
			4: 'Thu',
			5: 'Fri',
			6: 'Sat',
		},
	},
	user_removal: {
		reasons: {
			self: 'Your own account cannot be removed.',
			last_remover: 'This is the last person allowed to remove people.',
			referenced: '{count} entries in {table}.{column} refer to the person.',
		},
	},
};
